/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Scene_Description_Job_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Shot Description Job" |
*
* @param {Delete_Scene_Description_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_scene_description_job_title = /** @type {((inputs?: Delete_Scene_Description_Job_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Scene_Description_Job_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la description du poste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreibung der Aufnahme löschen Job")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina la descrizione dell'inquadratura Lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить описание кадра. Работа.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar descripción de disparo trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除镜头描述工作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("削除ショットの説明 仕事")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण हटाएं नौकरी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir descrição do trabalho")
	return /** @type {LocalizedString} */ ("Delete Shot Description Job")
});